import React, {useState} from "react"
import {Field} from "formik"

import {Card, CardContent, Grid, makeStyles, Typography} from "@material-ui/core"
import { TextField } from "formik-material-ui"
import Autocomplete, {createFilterOptions} from '@material-ui/lab/Autocomplete'

const useStyles = makeStyles(theme => ({
    fullWidth: {
        'width': '100%'
    },
    card: {
        'width': '100%',
        'border-radius': 'unset'
    },
    label: {
        'color': 'rgba(0, 0, 0, 0.54)',
        'padding': '0',
        'font-size': '0.75rem',
        'font-weight': '400',
        'line-height': '1',
        'letter-spacing': '0.00938em'
    }
}))

export const FieldNeedle = (props) => {
    const classes = useStyles()

    const { id, label, items, setFieldValue, isSubmitting, disabled } = props
    const [name] = useState(props.hasOwnProperty('name') ? props.name : `attributes.${id}`)
    const [value, setValue] = useState(props.value)

    return (
        <Grid item className={classes.fullWidth}>
            <Card className={classes.card}>
                <CardContent>
                    <Grid item className={classes.fullWidth}>
                        <Grid container direction='column' justify='center' alignItems='center' spacing={2}>
                            <Grid item className={classes.fullWidth}>
                                <Grid container direction='row' justify='space-between' alignItems='center' spacing={2}>
                                    <Grid item sm={9} className={classes.fullWidth}>
                                        <Typography variant="caption" className={classes.label}>{label}</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item className={classes.fullWidth}>
                                <Grid container direction='row' justify='space-between' alignItems='flex-start' spacing={2}>
                                    <Grid item className={classes.fullWidth}>
                                        <Field
                                            fullWidth
                                            name={`${name}.information`}
                                            disabled={ isSubmitting || disabled }
                                            label="Информация об игле"
                                            component={ TextField }
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container direction='row' justify='space-between' alignItems='flex-start' spacing={2}>
                                    <Grid item xs={6} className={classes.fullWidth}>
                                        <Field
                                            fullWidth
                                            name={`${name}.gauge.value`}
                                            disabled={ isSubmitting || disabled }
                                            label="Размер Gauge"
                                            component={ TextField }
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container direction='row' justify='space-between' alignItems='flex-start' spacing={2}>
                                    <Grid item sm={6} className={classes.fullWidth}>
                                        <Field
                                            fullWidth
                                            name={`${name}.diameter.value`}
                                            type="number"
                                            disabled={ isSubmitting || disabled }
                                            label="Диаметр"
                                            inputProps={{
                                                step: 0.0001,
                                                onWheel: e => {
                                                    e.target.blur()
                                                    e.stopPropagation()
                                                    setTimeout(() => {
                                                        e.target.focus()
                                                    }, 0)
                                                }
                                            }}
                                            component={ TextField }
                                        />
                                    </Grid>
                                    <Grid item sm={6} className={classes.fullWidth}>
                                        <Field
                                            fullWidth
                                            name={`${name}.diameter.delimiter`}
                                            disabled={ isSubmitting || disabled }
                                            label="Разделитель"
                                            component={ TextField }
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container direction='row' justify='space-between' alignItems='flex-start' spacing={2}>
                                    <Grid item sm={6} className={classes.fullWidth}>
                                        <Field
                                            fullWidth
                                            name={`${name}.length.value`}
                                            type="number"
                                            disabled={ isSubmitting || disabled }
                                            label="Длина иглы"
                                            inputProps={{
                                                step: 0.0001,
                                                onWheel: e => {
                                                    e.target.blur()
                                                    e.stopPropagation()
                                                    setTimeout(() => {
                                                        e.target.focus()
                                                    }, 0)
                                                }
                                            }}
                                            component={ TextField }
                                        />
                                    </Grid>
                                    <Grid item sm={6} className={classes.fullWidth}>
                                        <Autocomplete
                                            filterOptions={createFilterOptions({
                                                matchFrom: 'start',
                                                stringify: option => (option instanceof Object) ? (option.short ?? '') : (option ?? '')
                                            })}
                                            options={ items }
                                            getOptionLabel={option => (option instanceof Object) ? (option.short ?? '') : (option ?? '')}
                                            disabled={ isSubmitting || disabled }
                                            onChange={(e, value) => {
                                                setFieldValue(`${name}.length.unit`, ((value instanceof Object) ? value.short : value))
                                            }}
                                            defaultValue={value.length.unit}
                                            renderInput={params => (
                                                <Field
                                                    fullWidth
                                                    {...params}
                                                    name={`${name}.length.unit`}
                                                    InputProps={{
                                                        ...params.InputProps,
                                                        onChange: (e) => {
                                                            setValue({
                                                                ...value,
                                                                ...{
                                                                    length: {
                                                                        ...value.length,
                                                                        ...{
                                                                            unit: e.target.value
                                                                        }
                                                                    }
                                                                }
                                                            })
                                                        }
                                                    }}
                                                    type="text"
                                                    label="Ед. изм."
                                                    component={ TextField }
                                                />
                                            )}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container direction='row' justify='space-between' alignItems='flex-start' spacing={2}>
                                    <Grid item sm={6} className={classes.fullWidth}>
                                        <Field
                                            fullWidth
                                            name={`${name}.length.delimiter`}
                                            disabled={ isSubmitting || disabled }
                                            label="Разделитель"
                                            component={ TextField }
                                        />
                                    </Grid>
                                    <Grid item sm={6} className={classes.fullWidth}>
                                        <Field
                                            fullWidth
                                            name={`${name}.amount`}
                                            type="number"
                                            disabled={ isSubmitting || disabled }
                                            label="Количество"
                                            inputProps={{
                                                step: 0.0001,
                                                onWheel: e => {
                                                    e.target.blur()
                                                    e.stopPropagation()
                                                    setTimeout(() => {
                                                        e.target.focus()
                                                    }, 0)
                                                }
                                            }}
                                            component={ TextField }
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container direction='row' justify='space-between' alignItems='flex-start' spacing={2}>
                                    <Grid item sm={6} className={classes.fullWidth}>
                                        <Field
                                            fullWidth
                                            name={`${name}.gauge.additional`}
                                            disabled={ isSubmitting || disabled }
                                            label="Размер Gauge (доп.)"
                                            component={ TextField }
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container direction='row' justify='space-between' alignItems='flex-start' spacing={2}>
                                    <Grid item sm={6} className={classes.fullWidth}>
                                        <Field
                                            fullWidth
                                            name={`${name}.bend`}
                                            disabled={ isSubmitting || disabled }
                                            label="Степень изгиба"
                                            component={ TextField }
                                        />
                                    </Grid>
                                    <Grid item sm={6} className={classes.fullWidth}>
                                        <Field
                                            fullWidth
                                            name={`${name}.description`}
                                            disabled={ isSubmitting || disabled }
                                            label="Текст"
                                            component={ TextField }
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Grid>
    )
}
